import { AuthService } from './../../shared/services/auth.service';
import { User } from './../../models/User';
import { environment } from 'src/environments/environment';
import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRouteSnapshot, NavigationEnd, Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { filter } from 'rxjs/operators';

import { AccountVersionService, INTERNATIONAL } from './../../shared/services/account-version.service';
import { MenuService } from './menu/menu.service';

@Component({
  templateUrl: './layout.component.html',
  styleUrls: ['./layout.component.scss']
})
export class LayoutComponent implements OnInit, OnDestroy {

  get supportLink() {
    return environment.supportLink;
  }

  user: User;

  isSmallDevice = true;

  /**
   * Barra expandida ou em trilho. No desktop o conteúdo ocupa o que a barra
   * deixa: recolhida, sobra a largura do trilho (CU-86akkvmxc).
   */
  isMenuVisible = true;

  /** Dirige a classe de tema do shell; os tokens vivem em `src/theme.scss`. */
  isInternational = false;

  /**
   * Tela que declara `data: { hideSupportButton: true }` na rota fica sem o botão flutuante de
   * "Fale conosco". Conversas (30/09/2026): o botão cobria o campo de resposta e o botão de
   * enviar, e numa tela de WhatsApp um segundo ícone do WhatsApp só confunde.
   */
  hideSupportButton = false;

  private subscriptions: Subscription[] = [];

  /** Multiusuários: o membro se apresenta ao suporte com o próprio nome, não o do dono. */
  get supportName(): string {
    return this.authService.currentMember?.name ?? this.user?.name;
  }

  constructor(
    private menuService: MenuService,
    private authService: AuthService,
    private accountVersionService: AccountVersionService,
    private router: Router
  ) { }

  ngOnInit(): void {
    this.subscriptions.push(
      this.menuService
        .getIsSmallDevice()
        .subscribe(isSmallDevice => setTimeout(() => this.isSmallDevice = isSmallDevice, 200))
    );

    this.subscriptions.push(
      this.menuService
        .getMenuVisibility()
        .subscribe(isVisible => this.isMenuVisible = isVisible)
    );

    this.subscriptions.push(
      this.accountVersionService
        .getVersion()
        .subscribe(version => this.isInternational = version === INTERNATIONAL)
    );

    this.subscriptions.push(
      this.router.events
        .pipe(filter(event => event instanceof NavigationEnd))
        .subscribe(() => this.hideSupportButton = this.routeHidesSupportButton())
    );
    this.hideSupportButton = this.routeHidesSupportButton();

    this.user = this.authService.getUser();
  }

  /** Vale a marca em qualquer nível da rota ativa: quem declara costuma ser o módulo filho. */
  private routeHidesSupportButton(): boolean {
    let route: ActivatedRouteSnapshot | null = this.router.routerState?.snapshot?.root ?? null;
    while (route) {
      if (route.data?.['hideSupportButton']) {
        return true;
      }
      route = route.firstChild;
    }
    return false;
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach(subscription => subscription.unsubscribe());
  }

}
